// extracted by mini-css-extract-plugin
module.exports = {"ErrorCard":"ErrorCard_ErrorCard___QtZ4","ErrorCard_wrapper":"ErrorCard_ErrorCard_wrapper__kada8","ErrorCard_header":"ErrorCard_ErrorCard_header__DGi_N"};